module.exports = __webpack_public_path__ + "static/social-media-image-7b77168ec200f9c08b9a603dd9023070.jpg";